import { Component, OnInit } from '@angular/core';
import { ServiceLocalStorage } from '../core/services/local-storage.service';

@Component({
  selector: 'app-layouts',
  templateUrl: './layouts.component.html',
  styleUrls: ['./layouts.component.scss']
})
export class LayoutsComponent implements OnInit {
  mCurrentUserData: any;
  logoFlag: boolean;

  constructor(private readonly localStorage: ServiceLocalStorage) { }

  ngOnInit(): void {
    this.mCurrentUserData = this.localStorage.getUserObject();
    if (this.mCurrentUserData.userInfoDetails.site.location.company.logo !== '') {
      this.logoFlag = true;
    } else {
      this.logoFlag = false;
    }
  }
}
